import { trackUserLogged, trackUserFreemiumLoginWallCtaClicked, trackUserFreemiumLoginWallViewed, trackUserFreemiumSuccessfulLogin, trackUserFreemiumSuccessfulSignup } from "../tracking/helpers";
import { snowplowInit, setupAuth0UserTracking, clearUserTracking } from "../tracking/snowplow/snowplowInit";
import { updateWalledElements } from "./helpers";

const configureClient = async () => {
  window.auth0Client = await auth0.createAuth0Client({
    domain: window.forgeVariables.auth0.domain,
    clientId: window.forgeVariables.auth0.clientId,
    useRefreshTokens: true,
    cacheLocation: "localstorage",
  });
};

export const login = async (redirect_uri = null) => {
  if (window.auth0Client) {
    await window.auth0Client.loginWithRedirect({
      authorizationParams: {
        redirect_uri: redirect_uri ? redirect_uri : `${window.location.origin}/mlsid/callback?return_uri=${window.location.pathname}`,
        connection: "fan-id",
        display: "signin",
        prompt: "login"
      },
    });
  }
};

const logout = async () => {
  if (window.auth0Client) {
    clearUserTracking();
    await window.auth0Client.logout({
      clientId: window.forgeVariables.auth0.clientId,
      logoutParams: {
        returnTo: window.location.origin
      }
    });
  }
};

export const signUp = async (redirect_uri = null) => {
  if (window.auth0Client) {
    await window.auth0Client.loginWithRedirect({
      authorizationParams: {
        redirect_uri: redirect_uri ? redirect_uri : `${window.location.origin}/mlsid/callback?return_uri=${window.location.pathname}`,
        connection: "fan-id",
        display: "signup",
        prompt: "login"
      },
    });
  }
};

const updateWall = (isAuthenticated) => {
  if (isAuthenticated) {
    updateWalledElements(true);
  } else {
    updateWalledElements(false);
  }
};

const updateUI = async () => {
  if (window.auth0Client) {
    const isAuthenticated = await window.auth0Client.isAuthenticated();
    const query = window.location.search;
    const params = new URLSearchParams(query);
    const freemiumType = params.get("freemiumType");
    const event = params.get("event");
    const signupType = params.get("signupType");
    const method = params.get("method") || "";

    if (window.dataLayerInitialized) {
      if (isAuthenticated) {
        const user = await window.auth0Client.getUser();
        const sub = user?.sub;

        if (sub) {
          window.dataLayer.push({
            ...window.dataLayerInitialized,
            userId: user?.sub
          });
        }
      }
    }

    updateWall(isAuthenticated);

    if (isAuthenticated) {

      if (event === "successful-signup" && event && signupType) {
        trackUserFreemiumSuccessfulSignup({
          freemiumType,
          event,
          signupType,
          method
        });
      }

      if (event === "successful-login-freemium" && freemiumType) {
        trackUserFreemiumSuccessfulLogin({
          freemiumType,
          event,
          method
        });
      }

      const accountSelector = document.querySelectorAll(
        ".mls-o-navigation__item-link--account"
      );

      if (accountSelector?.length) {
        accountSelector.forEach((el) =>
          el.setAttribute("href", "/mlsid/profile")
        );
      }

      const accountIconSelector = document.querySelectorAll(
        ".mls-o-navigation__item-link--account .oc-o-icon--mls-profile"
      );
      if (accountIconSelector?.length) {
        accountIconSelector.forEach((el) => el.classList.remove("d-none"));
      }

      const accountTextSelector = document.querySelectorAll(
        ".mls-o-navigation__item-link--account .mls-o-navigation__item-text"
      );
      if (accountTextSelector?.length) {
        accountTextSelector.forEach((el) => el.classList.add("d-none"));
      }

      const profile = await window.auth0Client.getUser();
      const profilePage = document.querySelector(".mls-c-auth0-profile");

      if (profile && profilePage) {
        const accountContainer = document.querySelector(".mls-c-account_info");
        const divider = document.querySelector(".mls-c-account__divider");
        const logoutButton = document.querySelector(".mls-c-account__logout-button");
        const connectedAccountsContainer = document.querySelector(".mls-c-account__connected_accounts--title");
        const appleAccount = document.querySelector(".mls-c-account__connected_accounts--apple");
        const fbAccount = document.querySelector(".mls-c-account__connected_accounts--facebook");

        if (accountContainer) {
          accountContainer.style.display = "grid";
        }

        if (divider) {
          divider.style.display = "block";
        }

        if (logoutButton) {
          logoutButton.style.display = "block";
        }

        const nameContainer = document.querySelector(
          ".mls-c-account__name"
        );
        const emailContainer = document.querySelector(
          ".mls-c-account__email"
        );

        const favoriteClubContainer = document.querySelector(
          ".mls-c-account__favorite-club-wrapper"
        );

        const favoriteClubEl = document.querySelector(
          ".mls-c-account__favorite-club"
        );

        if (nameContainer) nameContainer.innerHTML = profile?.given_name && profile?.family_name ? profile?.given_name + " " + profile?.family_name : profile?.nickname;
        if (emailContainer) emailContainer.innerHTML = profile?.email;
        if (profile?.user_metadata?.favorite_club_opta_id) {
          const clubsUrl = `${window.forgeVariables.apiList.forgeDAPI}/content/${window.forgeVariables.currentSite.culture}/clubs?fields.inMLSCompetition=true&$skip=0&$limit=99`
          const clubs = await fetch(clubsUrl)
            .then((res) => res.json())
            .catch((_) => []);

          if (clubs?.items?.length) {
            const optaId = profile.user_metadata.favorite_club_opta_id;
            const club = clubs?.items.find((club) => club.fields.optaId == optaId);
            if (club && favoriteClubContainer && favoriteClubEl) {
              favoriteClubContainer.style.display = "block";
              favoriteClubEl.innerHTML = club.title;
            }
          }
        }

        if (connectedAccountsContainer && appleAccount && profile?.sub?.includes("apple")) {
          appleAccount.style.display = "block";
          connectedAccountsContainer.style.display = "flex";
        }

        if (connectedAccountsContainer && fbAccount && profile?.sub?.includes("facebook")) {
          fbAccount.style.display = "block";
          connectedAccountsContainer.style.display = "flex";
        }

        if (!profile?.sub?.includes("facebook") && !profile?.sub?.includes("apple")) {
          const connectedAccountsTitle = document.querySelector(".mls-c-account__connected_accounts--title");
          if (connectedAccountsTitle) {
            connectedAccountsTitle.style.display = "none";
          }
        }
      }

      return;
    } else {

      const wall = document.querySelector(".mls-account-wall");

      if (wall) {
        trackUserFreemiumLoginWallViewed({
          freemiumType: 'article'
        });
      }

      const accountTextSelector = document.querySelectorAll(
        ".mls-o-navigation__item-link--account .mls-o-navigation__item-text"
      );

      const signinButton = document.querySelector(".mls-c-account__signin-button");

      if (signinButton) {
        signinButton.style.display = "block";
      }

      if (accountTextSelector?.length) {
        accountTextSelector.forEach((el) => el.classList.remove("d-none"));
      }
    }

    if (query.includes("code=") && query.includes("state=")) {
      // Process the login state
      await window.auth0Client.handleRedirectCallback();

      updateUI();
    }
  }
};


export const initializeAuth = async () => {
  const callbackEvent = new Event("callback_check");
  snowplowInit();
  await configureClient();
  await updateUI();
  await setupAuth0UserTracking();
  document.dispatchEvent(callbackEvent);

  const signUpButton = document.querySelector(
    ".mls-c-account__sign-up--button"
  );

  const accountLoginButton = document.querySelector('.mls-o-navigation__item-link--login .mls-o-navigation__item-text');
  const accountLoginButtonMobile = document.querySelectorAll('.mls-o-navigation__item-link--login-mobile .mls-o-navigation__item-text');
  const profileSigninButton = document.querySelector(".mls-c-account__signin-button");

  const loginButton = document.querySelector(".mls-c-account__sign-in--button");
  const signUpWallButton = document.querySelector(".mls-account-wall__btn");
  const signInWallButton = document.querySelector(".mls-account-wall__use-profile");
  const logoutButton = document.querySelector(".mls-c-account__logout-button");

  if (signUpButton) {
    signUpButton.onclick = () => signUp();
  }

  if (logoutButton) {
    logoutButton.onclick = () => logout();
  }

  if (loginButton) {
    loginButton.onclick = () => login();
  }

  if (signInWallButton) {
    signInWallButton.onclick = () => {
      trackUserFreemiumLoginWallCtaClicked({
        freemiumType: "article",
        ctaAction: "signin"
      });
      const redirect_uri = `${window.location.origin}/mlsid/callback?return_uri=${window.location.pathname}&freemiumType=article&event=successful-login-freemium`
      login(redirect_uri);
    };
  }

  if (signUpWallButton) {
    signUpWallButton.onclick = () => {
      trackUserFreemiumLoginWallCtaClicked({
        freemiumType: "article",
        ctaAction: "signup"
      });
      const redirect_uri = `${window.location.origin}/mlsid/callback?return_uri=${window.location.pathname}&freemiumType=article&event=successful-signup&signupType=freemium`
      signUp(redirect_uri);
    }
  }

  if (accountLoginButton) {
    accountLoginButton.onclick = () => login();
  }
  if (profileSigninButton) {
    profileSigninButton.onclick = () => login();
  }


  if (accountLoginButtonMobile?.length) {
    accountLoginButtonMobile.forEach((el) =>
      el.onclick = () => login()
    );
  }

};
